<script setup>
// ABOUTME: City detail community results list.
// ABOUTME: Fetches the city communities API and reuses shared card hearts.

import { computed, onMounted, ref } from 'vue';

import ListingsCommunityCards from '../../../community-search/vue-app/src/components/ListingsCommunityCards.vue';

const mountEl = document.getElementById('city-vue-app');
const apiUrl = mountEl?.dataset?.apiUrl || '';
const fallbackThumbnail = mountEl?.dataset?.fallbackThumbnail || '';

const communities = ref([]);
const count = ref(0);
const selectedSort = ref('');
const isLoading = ref(true);
const error = ref('');

const hasEmptyState = computed(() => !isLoading.value && !error.value && communities.value.length === 0);

function syncCountLabel() {
    const el = document.querySelector('.city-results__count');
    if (el) {
        el.textContent = `${count.value} Found`;
    }
}

async function fetchCommunities() {
    isLoading.value = true;
    error.value = '';
    try {
        const url = new URL(apiUrl, window.location.origin);
        if (selectedSort.value) {
            url.searchParams.set('sort', selectedSort.value);
        }
        const filterParams = typeof window.collectCityFilterSearchParams === 'function'
            ? window.collectCityFilterSearchParams()
            : null;
        if (filterParams) {
            filterParams.forEach((value, key) => {
                url.searchParams.append(key, value);
            });
        }
        const response = await fetch(url.toString(), {
            headers: { Accept: 'application/json' },
        });
        if (!response.ok) {
            throw new Error('Unable to load communities right now.');
        }
        const data = await response.json();
        count.value = Number(data.count) || 0;
        communities.value = Array.isArray(data.results) ? data.results : [];
        syncCountLabel();
    } catch (caught) {
        error.value = caught.message || 'Unable to load communities right now.';
    } finally {
        isLoading.value = false;
    }
}

function setSort(sort) {
    selectedSort.value = sort;
    fetchCommunities();
}

function formatNumber(value) {
    if (value === null || value === undefined || value === '') return 'N/A';
    const parsed = Number(value);
    if (Number.isNaN(parsed)) return 'N/A';
    return parsed.toLocaleString();
}

function formatCommunityPrice(rentalsValue, salesValue) {
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        const parsed = Number(value);
        if (Number.isNaN(parsed)) {
            return null;
        }
        return `$${parsed.toLocaleString()}`;
    };

    const parts = [];
    const rentals = formatCurrency(rentalsValue);
    const sales = formatCurrency(salesValue);

    if (rentals) {
        parts.push(`Rentals from ${rentals}`);
    }
    if (sales) {
        parts.push(`Sales from ${sales}`);
    }

    if (parts.length === 0) {
        return '\u00A0';
    }

    return `${parts.join(', ')}.`;
}

function resolveThumbnail(thumbnailUrl) {
    return thumbnailUrl || fallbackThumbnail;
}

window.cityResults = { fetchCommunities, setSort };

onMounted(() => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fetchCommunities, { once: true });
        return;
    }
    fetchCommunities();
});
</script>

<template>
    <ListingsCommunityCards
        :communities="communities"
        :is-loading="isLoading"
        :error="error"
        :has-empty-state="hasEmptyState"
        :format-number="formatNumber"
        :format-community-price="formatCommunityPrice"
        :resolve-thumbnail="resolveThumbnail"
    />
</template>
